
import { Helmet } from "react-helmet-async";

const MainPageHelmet = () => {
  return (
    <Helmet>
      <title>Daily Fortune | Get Your Fortune Cookie Today</title>
      <meta name="description" content="Receive daily fortune cookie wisdom and inspiration. Crack open a virtual fortune cookie and discover what fate has in store for you today." />
      <meta name="keywords" content="fortune cookie, daily fortune, wisdom, inspiration, luck" />
      <meta property="og:title" content="Daily Fortune | Virtual Fortune Cookies" />
      <meta property="og:description" content="Get your daily dose of wisdom and inspiration with our virtual fortune cookie experience." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="/fortune" />
      <meta property="og:image" content="/fortune-cookie-og.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Daily Fortune | Virtual Fortune Cookies" />
      <meta name="twitter:description" content="Receive daily wisdom and inspiration with our virtual fortune cookie experience." />
      <link rel="canonical" href="/fortune" />
    </Helmet>
  );
};

export default MainPageHelmet;
